import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7e4d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OAtributosEsperados",
  "data-testid": "atributos-esperados"
}
const _hoisted_2 = { class: "OAtributosEsperados__AtributosForms" }
const _hoisted_3 = { class: "OAtributosEsperados__Table" }

import { ColunasAtributos } from "@/types/atributo"
  import { ALinhaDivisora } from "@/components/Gerais"
  import { OTabelaAtributos } from "@/components/Atributos"
  import { useI18n } from "vue-i18n"
  import { ParamsAtributo } from "@/repositorios/atributos/atributos.modelos"

  interface Props {
    aguardandoAlgumaReq?: boolean
    ocultarColunas?: ColunasAtributos[]
    parametros?: ParamsAtributo
    ocultarNatureza?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAtributosEsperados',
  props: {
    aguardandoAlgumaReq: { type: Boolean },
    ocultarColunas: null,
    parametros: null,
    ocultarNatureza: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    aguardandoAlgumaReq?: boolean
    ocultarColunas?: ColunasAtributos[]
    parametros?: ParamsAtributo
    ocultarNatureza?: boolean
  }

  

  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ALinhaDivisora), {
      content: _unref(t)('atributosEsperados')
    }, null, 8, ["content"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, {
        "aguardando-alguma-req": __props.aguardandoAlgumaReq,
        parametros: __props.parametros,
        "ocultar-natureza": props.ocultarNatureza
      }, null, 8, ["aguardando-alguma-req", "parametros", "ocultar-natureza"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(OTabelaAtributos), {
        "aguardando-alguma-requisicao": __props.aguardandoAlgumaReq,
        "ocultar-colunas": __props.ocultarColunas
      }, null, 8, ["aguardando-alguma-requisicao", "ocultar-colunas"])
    ])
  ]))
}
}

})